var _ = require('ES/lib/lodash');
var Balboa = require('ES/services/Balboa');
var ServicesUtils = require('ES/utils/ServicesUtils');

module.exports.init = _.once(function () {

    ServicesUtils.RadioAjax('read_ClientPortal_config', function (sid, success, failure) { //reads everything but the questionnaire
        Balboa.api('/clientportal/config/' + sid + '/read', {}, function (data) {
            success(sid, data.data);
        }, function (data) {
            failure(sid, (data && data.message) || 'unknown cause');
        });
    });


    ServicesUtils.RadioAjax('save_ClientPortal_links', function (sid, data, success, failure) {
        Balboa.api('/clientportal/config/' + sid + '/change_urls', {config: data},
            function (data) {
                success(sid, data.data);
            }, function (data) {
                failure(sid, (data && data.message) || 'unknown cause');
            });
    });


    ServicesUtils.RadioAjax('save_ClientPortal_questionnaire', function (sid, data, success, failure) {
        Balboa.api('/clientportal/config/' + sid + '/change_questionnaire', {config: data},
            function (data) {
                success(sid, data.data);
            }, function (data) {
                failure(sid, (data && data.message) || 'unknown cause');
            });
    });

    ServicesUtils.RadioAjax('save_ClientPortal_displayfields', function (sid, data, success, failure) {
        Balboa.api('/clientportal/config/' + sid + '/change_displayfields', {config: data},
            function (data) {
                success(sid, data.data);
            }, function (data) {
                failure(sid, (data && data.message) || 'unknown cause');
            });
    });

});



// WEBPACK FOOTER //
// ./src/services/ClientPortalConfig.js